import TextToSpeechBody from './TextToSpeechBody';

const TextToSpeechEdit = (props) => <TextToSpeechBody isEditMode {...props} />;

export default TextToSpeechEdit;
